module.exports = __webpack_public_path__ + "img/Unternehmen_Slider_Leidenschaft.png";